<template>
  <div class="overall-bg p-0">
    <b-row>
      <b-col cols="2" lg="2" md="6" sm="6">
        <div class="field">
          <Datepicker v-model="StockForm.stockdate" :rules="{ required: false }" :required-icon="false"
            :dateFormat="'dd/mm/yy'" :maxDate="maxDate" />
        </div>
      </b-col>
    </b-row>

    <b-row class="tabviewtable mt-3">
      <div class="panel">
        <b-col cols="2" class="panelfield br1">
          <div>
            <p class="amountfield">&#8377; {{ totalInwardValue }}</p>
            <p class="CountMax">+{{ totalInwardQty }} items</p>
            <p class="lighttext">Inward transcations</p>
          </div>
        </b-col>
        <b-col cols="2" class="panelfield br1 pe-3">
          <div>
            <p class="amountfield">&#8377; {{ totalOutwardValue }}</p>
            <p class="CountMin">+{{ totalOutward }} items</p>
            <p class="lighttext">Outward transcations</p>
          </div>
        </b-col>
        <b-col cols="2" class="balanceSec">
          <div>
            <div>
              <p class="amountfield1">&#8377; {{ openingBalance }}</p>
              <p class="balance">Opening balance</p>
            </div>
            <div>
              <p class="amountfield1">&#8377; {{ ClosingBalance }}</p>
              <p class="balance">Closing balance</p>
            </div>
          </div>
        </b-col>
      </div>
    </b-row>
    <b-row>
      <div class="form-white-bg" v-if="windowWidth > 545">
        <SkeletonTableLoader :columns="headers" :loading="loading" />
        <div v-if="!loading">
          <!-- {{List[0]}} -->
          <Tableview :value="List" :paginator="true" class="p-datatable-gridlines" :rows="10" dataKey="ItemCode"
            :rowHover="true" filterDisplay="menu" responsiveLayout="scroll" :columns="headers" :exceldownload="true"
            :globalFilterFields="globalFilterFields" :filters="filters" :options="List" selectionMode="single"
            @row-click="" :serialNumber="true" :searchbox="false" :searchbox1="true" @search="SearchOption"
            :showColumnFilters="false">
            <template v-slot:exceldownload>
              <ExportOption @ExportExcel="ExportExcel" @ExportPDF="ExportPDF" :ExportList="ExportList"
                :PageName="PageName" class="ms-2" :ExportOption="ExportOption" :HideAndShow="true" />
            </template>
            <template v-slot:dropdownfilter>
              <div class="d-flex align-items-center me-3">
                <MultiSelectDropDown textField="name" valueField="id" label="" placeholder="Category"
                  v-model="StockForm.category" :items="uniqueCategories" />
              </div>
            </template>
          </Tableview>
        </div>
      </div>
      <div v-if="windowWidth <= 545">
        <MobileLoader v-if="loading" />
        <div v-if="!loading">
          <MobileViewCardHeader v-if="List.length !== 0">
            <template v-slot:mobilecard>
              <div class="mobile-card" v-for="item in List">
                <div class="d-flex align-items-center justify-content-between">
                  <div class="d-flex align-items-center gap-1">
                    <p class="light-name">{{ item["ItemCategoryName"] }}</p>
                    <!-- <p class="light-name">{{ item["DocDate"] }}</p> -->
                  </div>
                  <i class="pi pi-ellipsis-v"></i>
                </div>
                <div class="d-flex align-items-center gap-2">
                  <p class="light-name">Item Name :</p>
                  <p class="small-name">{{ item["ItemName"] }}</p>
                </div>
                <div class="d-flex align-items-center gap-2">
                  <p class="light-name">Item Code :</p>
                  <p class="small-name">{{ item["ItemCode"] }}</p>
                </div>
                <div class="d-flex align-items-center gap-2">
                  <p class="light-name">Open Qty:</p>
                  <p class="small-name">{{ item["OpenQTY"] }}</p>
                </div>
                <div class="d-flex align-items-center gap-2">
                  <p class="light-name">Open Value :</p>
                  <p class="small-name">{{ item["OpenValue"] }}</p>
                </div>
                <div class="d-flex align-items-center gap-2">
                  <p class="light-name">Inward Qty:</p>
                  <p class="small-name">{{ item["InwardQTY"] }}</p>
                </div>
                <div class="d-flex align-items-center gap-2">
                  <p class="light-name">Inward Value:</p>
                  <p class="small-name">{{ item["InwardValue"] }}</p>
                </div>
                <div class="d-flex align-items-center gap-2">
                  <p class="light-name">Outward Qty:</p>
                  <p class="small-name">{{ item["OutwardQTY"] }}</p>
                </div>
                <div class="d-flex align-items-center gap-2">
                  <p class="light-name">Outward Value:</p>
                  <p class="small-name">{{ item["OutwardValue"] }}</p>
                </div>
                <div class="d-flex align-items-center gap-2">
                  <p class="light-name">Close Qty:</p>
                  <p class="small-name">{{ item["CloseQTY"] }}</p>
                </div>
                <div class="d-flex align-items-center gap-2">
                  <p class="light-name">Close Value:</p>
                  <p class="small-name">{{ item["CloseValue"] }}</p>
                </div>
              </div>
            </template>
          </MobileViewCardHeader>
        </div>
      </div>
    </b-row>
  </div>
</template>

<script lang="ts">
import { defineComponent, ref, onMounted, watch } from "vue";
// import CustomMultiSelectDropdown from "../../../../components/FormComponents/MultiSelectDropdown.vue";
import MobileViewCardHeader from "../../../../components/FormComponents/MobileViewCardHeader.vue";
import Tableview from "../../../../components/FormComponents/Table.vue";
import { FilterMatchMode, FilterOperator } from "primevue/api";
import SkeletonTableLoader from "../../../../components/FormComponents/SkeletonTableLoader.vue";
import ItemStoreMappingService from "../../../../modules/Inventory/Service/ItemStoreMappingService";
import { useRouter, useRoute } from "vue-router";
import Datepicker from "../../../../components/FormComponents/DatePicker.vue";
import MobileLoader from "../../../../components/SkeletonLoaderComponents/ContactCardView.vue";
import MultiSelectDropDown from "../../../../components/FormComponents/MultiSelectDropdown.vue";
import ExportOption from "../../../../components/FormComponents/Export.vue";
import service from "../../../../modules/Inventory/Service/ItemMasService";
import moment from "moment";
import { useI18n } from "vue-i18n";
import debounce from "lodash/debounce";

export default defineComponent({
  components: {
    Tableview,
    SkeletonTableLoader,
    Datepicker,
    MobileLoader,
    MobileViewCardHeader,
    MultiSelectDropDown,
    ExportOption,
  },
  setup(props, { emit }) {
    const placeholderDate = ref();
    const windowWidth = ref(window.innerWidth);
    const loading = ref(false);
    let Category = 0;
    const routes = useRoute();
    let storedId = routes.query.Id ?? 0;
    const totalOutward = ref("");
    const totalOutwardValue = ref("");
    const totalInwardQty = ref("");
    const totalInwardValue = ref("");
    const openingBalance = ref("");
    const ClosingBalance = ref("");
    const maxDate = new Date();
    let uniqueCategories: any = ref([]);
    const { t } = useI18n();
    Category = 0;
    let ExportOption = ref("");
    let ExportOptionHide = ref(true);
    let ExportList = ref([]);
    let categoryName = ref("0");
    let FirstLoad = ref(false);
    let StockForm = ref({
      category: [],
      stockdate: ref(""),
    });
    let PageName = ref("");
    onMounted(() => {
      debugger;
      categoryName.value = "0";
      loading.value = true;
      FirstLoad.value = true;
      const today = new Date();
      StockForm.value.stockdate = getToday(today);
      IsShow();
    });
    const getToday = (date: Date): string => {
      const date1 = new Date(date);
      if (isNaN(date1.getTime())) {
        throw new Error("Invalid date");
      }
      const year = date1.getFullYear();
      const month = (date1.getMonth() + 1).toString().padStart(2, "0");
      const day = date1.getDate().toString().padStart(2, "0");
      return `${day}-${month}-${year}`;
    };
    const getFormattedToday = (): string => {
      const today = new Date();
      return today.toISOString().split("T")[0];
    };

    const formatDateString = (date: Date): string => {
      const date1 = new Date(date);
      if (isNaN(date1.getTime())) {
        throw new Error("Invalid date");
      }
      const year = date1.getFullYear();
      const month = (date1.getMonth() + 1).toString().padStart(2, "0");
      const day = date1.getDate().toString().padStart(2, "0");
      return `${year}-${month}-${day}`;
    };
    let DateValue = ref();
    watch(
      () => StockForm.value.stockdate,
      (newValue) => {
        if (newValue && FirstLoad.value != true) {
          DateValue.value = StockForm.value.stockdate;
          DateValue.value = formatDateString(DateValue.value);
          loading.value = true;
          IsShow();
        }
      }
    );
    watch(
      () => StockForm.value.category,
      (newValue) => {
        debugger;
        categoryName.value = "0";
        categoryName.value = StockForm.value.category.toString();
        loading.value = true;
        IsShow();
      }
    );
    let fromExcel = ref(false);
    function ExportExcel() {
      debugger;
      ExportOption.value = "Excel";
      fromExcel.value = true;
      IsShow();
    }
    function ExportPDF() {
      debugger;
      ExportOption.value = "PDF";
      fromExcel.value = true;
      IsShow();
    }

    async function IsShow() {
      debugger;
      if (loading.value == true && fromExcel.value == false) {
        loading.value = true;
      } else if (loading.value == false && fromExcel.value == true) {
        loading.value = false;
      }
      try {
        DateValue.value =
          DateValue.value == undefined ? getFormattedToday() : DateValue.value;
        let response = await service.StockItemList(
          storedId,
          DateValue.value,
          categoryName.value == "" ? "0" : categoryName.value,
          routes.query.BranchId ?? 0
        );
        List.value = response["result"];
        debugger;
        let i = 0;
        let uniqueCategoriesSet = new Set();
        if (FirstLoad.value == true) {
          uniqueCategories.value = response["result"]
            .map((item) => ({
              value: item.ItemCategoryId,
              name: item.ItemCategoryName,
            }))
            .filter((item) => {
              if (!uniqueCategoriesSet.has(item.name)) {
                uniqueCategoriesSet.add(item.name);
                i += 1;
                return true;
              }
              i += 1;
              return false;
            });
          FirstLoad.value = false;
        }
        // totalOutward.value = Intl.NumberFormat('en-IN').format(response["result"][0].TotalOutQty);
        // totalOutwardValue.value = Intl.NumberFormat('en-IN').format(response["result"][0].TotalOutValuewithTax);
        // totalInwardQty.value = Intl.NumberFormat('en-IN').format(response["result"][0].TotalInQty);
        // totalInwardValue.value = Intl.NumberFormat('en-IN').format(response["result"][0].TotalInValuewithTax);
        // openingBalance.value = Intl.NumberFormat('en-IN').format(response["result"][0].TotalOpeningValue);
        // ClosingBalance.value = Intl.NumberFormat('en-IN').format(response["result"][0].TotalClosingValue);
        const totals = response["result"].reduce(
          (acc, item) => {
            acc.totalInwardQty += item.InwardQTY || 0;
            acc.totalOutward += item.OutwardQTY || 0;
            acc.totalInwardValue += item.InwardTaxValue || 0;
            acc.totalOutwardValue += item.OutwardTaxValue || 0;
            acc.openingBalance += item.OpeningTaxValue || 0;
            acc.closingBalance += item.ClosingTaxValue || 0;
            return acc;
          },
          {
            totalInwardQty: 0,
            totalOutward: 0,
            totalInwardValue: 0,
            totalOutwardValue: 0,
            openingBalance: 0,
            closingBalance: 0,
          }
        );

        totalInwardQty.value = Intl.NumberFormat("en-IN").format(
          totals.totalInwardQty
        );
        totalOutward.value = Intl.NumberFormat("en-IN").format(
          totals.totalOutward
        );
        totalInwardValue.value = Intl.NumberFormat("en-IN").format(
          totals.totalInwardValue
        );
        totalOutwardValue.value = Intl.NumberFormat("en-IN").format(
          totals.totalOutwardValue
        );
        openingBalance.value = Intl.NumberFormat("en-IN").format(
          totals.openingBalance
        );
        ClosingBalance.value = Intl.NumberFormat("en-IN").format(
          totals.closingBalance
        );

        List.value = response["result"].map((item) => {
          item.OpenValue = Intl.NumberFormat("en-IN").format(item.OpenValue);
          item.CloseValue = Intl.NumberFormat("en-IN").format(item.CloseValue);
          item.OutwardValue = Intl.NumberFormat("en-IN").format(
            item.OutwardValue
          );
          item.InwardValue = Intl.NumberFormat("en-IN").format(
            item.InwardValue
          );

          item.InwardTaxValue = Intl.NumberFormat("en-IN").format(
            item.InwardTaxValue
          );
          item.OutwardTaxValue = Intl.NumberFormat("en-IN").format(
            item.OutwardTaxValue
          );

          item.ClosingTaxValue = Intl.NumberFormat("en-IN").format(
            item.ClosingTaxValue
          );

          return item;
        });

        CopyList.value = List.value;

        if (fromExcel.value == true) {
          PageName.value = DateValue.value + " " + "Closing Stock";

          ExportList.value = response["result"].map((item) => {
            const filteredItem = {};
            headers.forEach(({ header, field }) => {
              filteredItem[header] = item[field];
            });
            return filteredItem;
          });
          fromExcel.value = false;
        }
      } catch {
        console.log("error");
      }
      loading.value = false;
      fromExcel.value = false;
    }
    const headers = [
      {
        header: t("storetabdetails.closingstocktableview.Code"),
        field: "ItemCode",
        slot: "TypeNameslot",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        class: "smallwidth coumnfreezeleft1",
      },

      {
        header: t("storetabdetails.closingstocktableview.Category"),
        field: "ItemCategoryName",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        bodyclass: "boldclass",
        class: "smallwidth coumnfreezeleft2",
      },
      {
        header: t("storetabdetails.closingstocktableview.ItemName"),
        field: "ItemName",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        bodyclass: "boldclass",
        class: "mediumwidth coumnfreezeleft3",
      },
      {
        header: t("storetabdetails.closingstocktableview.BrandModelSize"),
        field: "ItemConfiguratonName",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        sortable: false,
      },
      {
        header: t("storetabdetails.closingstocktableview.OpenQty"),
        field: "OpenQTY",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        sortable: false,
      },
      {
        header: t("storetabdetails.closingstocktableview.OpenValue"),
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        bodyclass: "bluecolor",
        field: "OpenValue",
      },
      {
        header: t("storetabdetails.closingstocktableview.InwardQty"),
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        bodyclass: "bluecolor",
        field: "InwardQTY",
      },
      {
        header: t("storetabdetails.closingstocktableview.Inwardvalue"),
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        field: "InwardValue",
      },
      {
        header: t("storetabdetails.closingstocktableview.InwardvalueWithTax"),
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        sortable: false,
        field: "InwardTaxValue",
      },
      {
        header: t("storetabdetails.closingstocktableview.OutwardQty"),
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        field: "OutwardQTY",
      },
      {
        header: t("storetabdetails.closingstocktableview.Outwardvalue"),
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        sortable: false,
        field: "OutwardValue",
      },
      {
        header: t("storetabdetails.closingstocktableview.OutwardvalueWithTax"),
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        sortable: false,
        field: "OutwardTaxValue",
      },
      {
        header: t("storetabdetails.closingstocktableview.CloseQty"),
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        field: "CloseQTY",
      },
      {
        header: t("storetabdetails.closingstocktableview.CloseValue"),
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        slot: "valslot",
        sortable: false,
        field: "CloseValue",
      },
      {
        header: t("storetabdetails.closingstocktableview.ClosingTaxValue"),
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        sortable: false,
        field: "ClosingTaxValue",
      },
    ];
    let List = ref([]);
    let CopyList: any = ref([]);

    const globalFilterFields = ref(headers.map((col) => col.field));
    const filters = {
      global: { value: null, matchMode: FilterMatchMode.CONTAINS },
      TypeNames: { value: null, matchMode: FilterMatchMode.IN, options: List },
      IsYearWise: { value: null, matchMode: FilterMatchMode.IN, options: List },
      StartValue: {
        value: null,
        matchMode: FilterMatchMode.IN,
        options: List,
      },
      NoOfDegits: {
        value: null,
        matchMode: FilterMatchMode.IN,
        options: List,
      },
      Suffix: { value: null, matchMode: FilterMatchMode.IN, options: List },
      Prefix: {
        value: null,
        matchMode: FilterMatchMode.IN,
        options: List,
      },
    };

    let SearchValue = ref();
    const debouncedSearch = debounce((input) => {
      let regex = new RegExp(input, "i");

      List.value = CopyList.value.filter((item) => {
        return Object.values(item).some((value) => regex.test(String(value)));
      });
    }, 300); // Adjust the delay as needed

    function SearchOption(Input) {
      debugger;
      SearchValue.value = Input;
      debouncedSearch(SearchValue.value);
    }

    return {
      SearchOption,
      headers,
      globalFilterFields,
      filters,
      List,
      windowWidth,
      loading,
      totalOutward,
      totalOutwardValue,
      totalInwardQty,
      totalInwardValue,
      openingBalance,
      ClosingBalance,
      uniqueCategories,
      StockForm,
      categoryName,
      IsShow,
      PageName,
      ExportExcel,
      ExportOption,
      ExportOptionHide,
      ExportList,
      ExportPDF,
      DateValue,
      placeholderDate,
      maxDate,
    };
  },
});
</script>
<style scoped lang="scss">
.main-panel {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: #f9fbfc;
  border: 1px solid #e1e1e1;
}

.amountfield {
  font-weight: 500;
  display: flex;
  align-items: center;
  justify-content: center;
}

.CountMax {
  color: #1cb722;
  font-size: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.CountMin {
  color: #e12a02;
  font-size: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.lighttext {
  color: #999999;
  font-size: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.balance {
  color: #ffffff;
  font-size: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.balanceSec {
  background-color: #3096ff;
  padding: 16px 0px 16px 0px;
}

.amountfield1 {
  font-weight: 500;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #ffffff;
}

.lighttext1 {
  color: #999999;
  font-size: 12px;
  display: flex;
}

.items {
  display: flex !important;
  justify-content: space-between;
  align-items: center;
}

.panelfield {
  display: flex;
  align-items: center;
}

.tabviewtable {
  border: 1px solid #e1e1e1;
}

.br1 {
  border-right: 1px solid #e1e1e1;
}

.excelbutton {
  height: 45px;
}

.datebtn {
  display: flex;
  justify-content: space-between;
}

.panel {
  display: flex;
  justify-content: space-around;
}
</style>
<style>
.p-multiselect-label-container {
  width: 200px !important;
  overflow: hidden !important;
}

.mobilesearch .addbtn {
  display: none !important;
}

.table-search .p-inputtext {
  padding: 0.45rem 0.55rem 0.45rem 2rem !important;
  width: 220px !important;
}
</style>
